import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import {
  ModalDismissReasons, NgbAccordionConfig, NgbActiveModal, NgbModal,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import {Phone, IPhone} from '../../shared/model/phone.model';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs/Rx';
import {PhoneService} from '../phone/phone.service';
import {PhoneTypeService} from '../phone-type/phone-type.service';
import {IPhoneType} from '../../shared/model/phone-type.model';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TransactionService} from '../transaction/transaction.service';
import {FieldActivityService} from '../field-activity/field-activity.service';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '../project/project.service';
import {EmployeeService} from '../../core/employee/employee.service';
import {JhiDataUtils} from 'ng-jhipster';
import {AccountService} from '../../singelton/account.service';
import {TranslateService} from '@ngx-translate/core';
import {IProject, Project} from '../../shared/model/project.model';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from '../action-type/action-type.service';
import {IEmployee} from '../../shared/model/employee.model';
import {IConnector} from "../../shared/model/connector.model";
import {ConnectorService} from "../connector/connector.service";
import {CustomerService} from "../customer/customer.service";
import {CustomerAdvancedSearchComponent} from "../customer/customer-advanced-search.component";
import {IOrder, Order} from "../../shared/model/order.model";
import {OrderService} from "./order.service";
import * as moment from 'jalali-moment';
import {FileObject, IFileObject} from "../../shared/model/file-object.model";
import {FileObjectService} from "../file/file-object.service";
import {IKala, Kala} from "../../shared/model/kala.model";
import {KalaService} from "../kala/kala.service";
import {IOrderItems, OrderItems} from "../../shared/model/orderItems.model";
import {KalaComponent} from "../kala/kala.component";
import {StockComponent} from "../stock/stock.component";
import {IStock, Stock} from "../../shared/model/stock.model";
import {EventService} from "../../singelton/event.service";
import {FileObjectUpdateComponent} from "../file/file-object-update.component";
import {FileDeleteDialogComponent} from "../file/file-delete-dialog.component";
import {FileObjectListProjectComponent} from "../file/file-object-list-project.component";
import {ICalendarTime} from "../../shared/model/calendarTime.model";
import {OrderItemsService} from "./order-items.service";
import {StockService} from "../stock/stock.service";
import {EventInput} from '@fullcalendar/core';
import {IncomingService} from "../incoming/incoming.service";
import {IIncoming} from "../../shared/model/incoming.model";
import {IncomingUpdateComponent} from "../incoming/incoming-update.component";

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-order-add',
  templateUrl: './order-add3.component.html',
  styleUrls: ['./order-add.component.scss']
})
export class OrderAddComponent implements OnInit {
  // phone: IPhone = new Phone();
  @Input() orderEdit;
  @Input() customerEdit;
  phone: IPhone = new Phone();
  login: any;
  order_temp: any = '-1';

  phones: IPhone[];
  phoneTypes: IPhoneType[];
  phoneTypes2: IPhoneType[];
  actionTypes: IActionType[];
  connectors: IConnector[];
  closeResult: string;

  transaction: ITransaction = new Transaction();
  employees: IEmployee[];
  keyword = 'audience';

  order: IOrder = new Order();
  order2: IOrder = new Order();
  customer: ICustomer = new Customer();
  project: IProject = new Project();
  phone_id: any;
  isSaving: boolean;
  isSaving2: boolean;

  Delivered: boolean = false;
  Approved: boolean = false;

  chekNeedReminder: Boolean = false;

  dateObject: any;
  dateObject2: any;

  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  fileObjects: IFileObject[] = [];
  stocks: IStock[] = [];
  showTypeOrgan = false;
  progress = 0;
  progress2 = 0;
  stock_temp: any='-1';

  nextCustomerFormShow = false;
  @Input() phoneEdit;
  public serverValidationError = false;
  strDateObject: any;
  strDateObject2: any;
  part: any;
  file: IFileObject = new FileObject();
  file_fileType: any;
  file_size: any;
  file_itemName: any;
  @Input() title;
  @Input() role;
  @Input() customerId;
  availableTime: ICalendarTime[];
  calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin];
  calendarWeekends = true;
  calendarEvents2: EventInput[] = [
    // { title: 'تست نیلا', start: new Date(), backgroundColor: 'red' },
    // {
    //   title: 'دکتر هلاکوا',
    //   start: '2021-03-24',
    //   end: '2021-04-12',
    //   backgroundColor: '#48ad13',
    //   padding: '2px',
    //   height: '5px',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'تست',
    //   start: '2021-03-30',
    //   end: '2021-05-12',
    //   backgroundColor: '#ffb704',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-03-30',
    //   end: '2021-06-12',
    //   backgroundColor: '#ff4852',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-03-30',
    //   end: '2021-06-12',
    //   backgroundColor: '#9deeff',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-03-30',
    //   end: '2021-06-12',
    //   backgroundColor: '#a211b4',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-03-30',
    //   end: '2021-06-12',
    //   backgroundColor: '#fffb21',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-04-08',
    //   end: '2021-06-30',
    //   backgroundColor: '#ff4852',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-05-30',
    //   end: '2021-07-30',
    //   backgroundColor: '#dfffca',
    //   description: 'This is a cool event'
    // },
    // {
    //   title: 'شرافت',
    //   start: '2021-03-30',
    //   end: '2021-06-12',
    //   backgroundColor: '#6f84ff',
    //   description: 'This is a cool event'
    // }
  ];
  orders_calendar: IOrderItems[] = [];

  editFormFile = this.fb.group({
    id: [],
    title: [],
    itemName: [],
    size: [],
    content: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    uploaded_by: [],
    contentType: []
  });

  editFormFile2 = this.fb.group({
    id: [],
    title: [],
    itemName: [],
    size: [],
    content: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    uploaded_by: [],
    contentType: []
  });

  selectEvent(item) {
    // this.order.audience = new Phone(item.id);
  }

  onChangeSearch(val: string) {
    this.order.audience = val;
  }

  onFocused(e) {
  }

  orderForm: FormGroup;
  items: FormArray;
  kalas: IKala[];
  kala: IKala = new Kala();
  stock: IStock = new Stock();
  stock2: IStock = new Stock();
  sum_amount_order_items: any = 0;
  sum_avarez_order_items: any = 0;
  sum_discount_order_items: any = 0;
  total_amount_order_final: any = 0;
  show_input_amount = true;
  let_add = true;
  orderIncomings: IIncoming[] = [];
  flowBusy = false;

  constructor(public activeModal: NgbActiveModal,
              public phoneTypeService: PhoneTypeService,
              protected customerService: CustomerService,
              protected fileObjectService: FileObjectService
    , private fb: FormBuilder,
              protected eventService: EventService,
              protected transactionService: TransactionService,
              protected activatedRoute: ActivatedRoute,
              protected fieldActivityService: FieldActivityService,
              protected connectorService: ConnectorService,
              protected stockService: StockService,
              private toastr: ToastrService,
              public projectService: ProjectService,
              public actionTypeService: ActionTypeService,
              private spinner: NgxSpinnerService,
              public employeeService: EmployeeService,
              protected dataUtils: JhiDataUtils,
              private modalService: NgbModal,
              protected phoneService: PhoneService,
              public accountService: AccountService,
              protected router: Router,
              private translate: TranslateService,
              protected orderService: OrderService,
              protected orderItemService: OrderItemsService,
              protected kalaService: KalaService,
              protected incomingService: IncomingService,
              config: NgbAccordionConfig
    , private  formBuilder: FormBuilder,
              // protected eventManager: JhiEventManager
  ) {
    this.itemsPerPage = 10;
    this.page = 1;
    this.predicate = 'itemName';
    this.reverse = 'asc';

  }

  ngOnInit() {
    this.loadOrdersCalnedar();
    this.loadAllStocksTotal();
    this.order.step = 1;
    if (!this.orderEdit) {
      this.order.status = 'pre_invoice';
      this.order.require_finance_approval = false;
    }

    this.activatedRoute.params.subscribe((params) => {
      this.orderEdit = params['id'];
      // this.customerId = params['cuctomerid'];
      this.customerId = params['cid'];
      this.part = params['part'];
      if (this.orderEdit) {
        this.loadOrderForEdit(this.orderEdit);
      }
    });
    this.accountService.identity().then(d => {
      this.login = d.login;
      this.setDefaultResponsible();
    });

    this.orderForm = this.formBuilder.group({
      status: [''],
      address_receiver: [''],
      phone_id: [''],
      strDateObject: [''],
      strDateObject2: [''],
      factor_number: [''],
      factor_payment_method: [''],
      factor_amount: ['', [Validators.required, Validators.maxLength(6)]],
      factor_type: [''],
      store_number: [''],
      send_method: [''],
      store_responsible: [''],
      payment_description: [''],
      items: this.formBuilder.array([this.createItem()])
    });

    this.kalaService.query(
      {
        page: this.page - 1,
        size: this.itemsPerPage,
        // sort: this.sort(this.predicate, this.reverse)
      }
    ).subscribe(
      // this.kalaService.findMyKala(employeeId).subscribe(
      (res: HttpResponse<IKala[]>) => {
        this.kalas = res.body;
        this.spinner.hide();

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
    if (this.orderEdit && !this.activatedRoute.snapshot.params['id']) {
      this.loadOrderForEdit(this.orderEdit);
    }

    if (this.customerId) {
      this.customerService.find(this.customerId).subscribe(
        (res: HttpResponse<IOrder>) => {
          this.customer = res.body;
          this.search();

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

    if (this.customerEdit) {
      this.customer = this.customerEdit;
      this.order.customer = this.customer;
      this.search();

    }
    if (!this.orderEdit) {
      this.removeItem(0)

    }
    // this.loadAllPhoneTypes();
    // // this.loadAllActionTypes();
    // this.loadAllEmployee();
    // this.loadAllConnector();
    this.loadAllEmployee();
  }

  loadOrderForEdit(orderId: any) {
    this.orderService.find(orderId).subscribe(
      (res: HttpResponse<IOrder>) => {
        this.order = res.body;
        this.order2 = res.body;
        if (this.order.status === 'delivered' || this.order.status === 'warehouse_issued') {
          this.Delivered = true;
          this.Approved = true;
        } else if (this.order.status === 'approved' || this.order.status === 'confirmed') {
          this.Approved = true;
        }
        this.loadAllFiles();
        this.loadOrderIncomings();

        if (this.order.phone) {
          this.phone_id = this.order.phone.id;
        }
        if (this.order.employee && this.order.employee.id) {
          this.order.employee_str = String(this.order.employee.id);
        }
        if (this.order.taxation) {
          this.order.taxation = this.numberWithCommas(this.order.taxation);
        }
        if (this.order.discount) {
          this.order.discount = this.numberWithCommas(this.order.discount);
        }
        if (this.order.send_order_date_str) {
          const jalaliDate5 = moment(this.order.send_order_date_str).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
          this.strDateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
        }
        if (this.order.return_order_date_str) {
          const jalaliDate6 = moment(this.order.return_order_date_str).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
          this.strDateObject2 = moment(jalaliDate6, 'jYYYY,jMM,jDD  HH:mm:ss');
        }

        this.updateForm(this.order);
        this.order.factor_amount = this.numberWithCommas(this.order.factor_amount);
        const orderItemTemp: any = <IOrderItems[]>this.order.orderItems;
        const length: any = (<IOrderItems[]>this.order.orderItems).length;
        const control = <FormArray>this.orderForm.controls['items'];
        if (length > 0) {
          this.show_input_amount = false;
        }
        for (let i = 0; i < length; i++) {
          this.addItem();
          this.updateItem(this.order.orderItems[i]);
          (<FormGroup>control.at(i)).controls.id.setValue(orderItemTemp[i].id);
          (<FormGroup>control.at(i)).controls.count.setValue(orderItemTemp[i].count);
          (<FormGroup>control.at(i)).controls.status.setValue(orderItemTemp[i].status);
          if (orderItemTemp[i].cost) {
            (<FormGroup>control.at(i)).controls.cost.setValue(this.numberWithCommas(orderItemTemp[i].cost));
          }
          (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(orderItemTemp[i].cost_total));
          (<FormGroup>control.at(i)).controls.discount.setValue((orderItemTemp[i].discount));
          (<FormGroup>control.at(i)).controls.kala.setValue(orderItemTemp[i].kala);
          (<FormGroup>control.at(i)).controls.stock.setValue(orderItemTemp[i].stock);
        }
        this.removeItem(length);
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllEmployee() {
    this.employeeService.query({page: 0, size: 500}).subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body || [];
        this.setDefaultResponsible();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  /** مسئول = کاربر لاگین‌شده (برای ثبت جدید یا وقتی هنوز خالی است) */
  setDefaultResponsible() {
    if (this.order.employee_str) {
      return;
    }
    this.accountService.identity().then(account => {
      if (!account) {
        return;
      }
      const userKey = account.id != null ? account.id : account.login;
      if (userKey == null || userKey === '') {
        return;
      }
      this.employeeService.findByUserId(userKey).subscribe(
        (empl: HttpResponse<IEmployee>) => {
          if (empl.body && empl.body.id && !this.order.employee_str) {
            this.order.employee_str = empl.body.id;
          } else if (!this.order.employee_str) {
            this.applyResponsibleFromEmployeeList(account);
          }
        },
        () => {
          if (!this.order.employee_str) {
            this.applyResponsibleFromEmployeeList(account);
          }
        }
      );
    });
  }

  sort4(predicate, reverse) {
    let result = ['id, asc'];
    // if (predicate) {
    //   result = [predicate + ',' + reverse];
      return result;
    // }
  }
  sort(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  private updateOrder(order: IOrder): void {
    const control = <FormArray>this.orderForm.controls['items'];
    for (let i = control.length - 1; i >= 0; i--) {
      if (!(<FormGroup>control.at(i)).controls.kala.value) {
        control.removeAt(i);
      }
    }
    this.updateOrder2(order);
  }

  private updateOrder2(order: IOrder): void {

    const control1 = <FormArray>this.orderForm.controls['items'];

    for (let i = control1.length - 1; i >= 0; i--) {

      if (!(<FormGroup>control1.at(i)).controls.kala.value) {
        control1.removeAt(i);
      } else {
        if ((<FormGroup>control1.at(i)).controls.cost_total.value !== null
          && (<FormGroup>control1.at(i)).controls.cost_total.value !== undefined
          && (<FormGroup>control1.at(i)).controls.cost_total.value !== '') {
          (<FormGroup>control1.at(i)).controls.cost_total.setValue(Number(this.disNumberWithCommas((<FormGroup>control1.at(i)).controls.cost_total.value + '')));
        }
        if ((<FormGroup>control1.at(i)).controls.cost.value !== null
          && (<FormGroup>control1.at(i)).controls.cost.value !== undefined
          && (<FormGroup>control1.at(i)).controls.cost.value !== '') {
          (<FormGroup>control1.at(i)).controls.cost.setValue(Number(this.disNumberWithCommas((<FormGroup>control1.at(i)).controls.cost.value + '')));
        }
      }
    }

    order.orderItems = this.orderForm.get(['items']).value;
  }


  private updateForm(order: IOrder): void {
    this.orderForm.patchValue({
      id: order.id,
      phone_id: order.phone_id,
      strDateObject: order.strDateObject,
      strDateObject2: order.strDateObject2,
      status: order.status,
      address_receiver: order.address_receiver,
      factor_payment_method: order.factor_payment_method,
      factor_type: order.factor_type,
      store_number: order.store_number,
      factor_number: order.factor_number,
      factor_amount: this.numberWithCommas(order.factor_amount),
      send_method: order.send_method,
      store_responsible: order.store_responsible,
      payment_description: order.payment_description,
      orderItems: order.orderItems,
    });
  }

  // numberWithCommasNumber(cost) {
  //   // const cost = this.contract.cost;
  //   const y = this.numberWithCommas(cost);
  //   const control = <FormArray>this.orderForm.controls['items'];
  //   if ((<FormGroup>control.at(i)).controls.cost.value && (<FormGroup>control.at(i)).controls.count.value) {
  //     (<FormGroup>control.at(i)).controls.cost_total.setValue(Number((<FormGroup>control.at(i)).controls.cost.value + "") * Number((<FormGroup>control.at(i)).controls.count.value));
  //   }
  //   // this.contract.cost = y;
  // }

  numberWithCommas(x) {
    if (x) {
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');

      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) {
        x = x.replace(pattern, '$1,$2');
      }
      return x;
    }
  }

  numberWithCommas2(y) {
    let x: any = Number(y);
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  disNumberWithCommas(x) {
    if (x === null || x === undefined || x === '') {
      return 0;
    }
    const cleaned = String(x).replace(/,/g, '');
    const n = Number(cleaned);
    return isNaN(n) ? 0 : n;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      kala: [null],
      stock: [null],
      status: [null],
      cost_total: [0],
      discount: [0],
      cost: [0],
      count: [1]
      // code: ''
    });
  }

  updateItem(orderItems: IOrderItems): void {
    this.orderForm.patchValue({
      id: orderItems.id,
      cost: (orderItems.cost ? this.disNumberWithCommas(orderItems.cost) : 0),
      cost_total: this.disNumberWithCommas(orderItems.cost_total),
      kala: orderItems.kala,
      stock: orderItems.stock,
      count: orderItems.count,
      discount: orderItems.discount,
      status: orderItems.status,
    });
  }

  clearForm() {
    window.history.back();
  }

  changeCost(i, val) {
    const control = <FormArray>this.orderForm.controls['items'];
    (<FormGroup>control.at(i)).controls.cost.setValue(val.cost);

  }

  addItem(): void {
    this.items = this.orderForm.get('items') as FormArray;
    this.items.push(this.createItem());
  }

  removeItem(i: number) {
    // this.changeValueCountForRemove(i);

    const control = <FormArray>this.orderForm.controls['items'];
    control.removeAt(i);

  }

  parseDateJalali(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }

  parseDateTimeJalali(value) {
    if (!value) {
      return '—';
    }
    return moment(new Date(value)).locale('fa').format('jYYYY/jM/jD HH:mm');
  }

  incomingTypeLabel(type: string): string {
    switch (type) {
      case 'cash': return 'نقدی';
      case 'credit': return 'اعتباری';
      case 'chek': return 'چک';
      case 'fund_chek': return 'چک صندوق';
      default: return type || '—';
    }
  }

  incomingStatusLabel(status: string): string {
    switch (status) {
      case 'settled': return 'تسویه شده';
      case 'unsettled': return 'تسویه نشده';
      case 'pending': return 'در انتظار';
      case 'canceled':
      case 'cancelled': return 'باطل شده';
      default: return status || '—';
    }
  }

  /** اقلام برای نمایش خواندنی و PDF (از سفارش یا فرم) */
  orderItemsList(): any[] {
    const raw: any = this.order && this.order.orderItems;
    let list: any[] = [];
    if (Array.isArray(raw)) {
      list = raw;
    } else if (raw && typeof raw === 'object') {
      list = Object.keys(raw).map(k => raw[k]).filter(Boolean);
    }
    list = (list || []).filter(it => it && (it.kala || it.count));
    if (list.length) {
      return list;
    }
    try {
      const formItems = this.orderForm && this.orderForm.get('items')
        ? (this.orderForm.get('items').value || [])
        : [];
      return formItems.filter((it: any) => it && it.kala && it.kala.id);
    } catch (e) {
      return [];
    }
  }

  nowForPrint(): Date {
    return new Date();
  }


  deleteFile(data: any) {
    const modalRef = this.modalService.open(FileDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'delete';
    modalRef.componentInstance.fileId = data;
    modalRef.componentInstance.fileEdit = data;

    modalRef.result.then(
      res => {
        this.loadAllFiles();
      },
      rejected => {
        this.loadAllFiles();
      }
    );
  }

  downloadFile(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  sort_2() {
    const result = ['audience' + ',' + (this.reverse)];
    return result;
  }

  search() {
    this.spinner.show();
    this.phoneService
      .findWithCustomerId(this.customer.id
      )
      .subscribe(
        (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  protected onError(errorMessage: string) {

    this.spinner.hide();

    // this.jhiAlertService.error(errorMessage, null, null);
  }

  protected paginatePhones(data: IPhone[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.phones = data;

    this.spinner.hide();

  }

  protected onSaveSuccess() {
    this.activeModal.dismiss('cancel');
  }

  protected onSaveError(response) {
    this.continueAfterSave = false;
    this.spinner.hide();
    this.isSaving = false;
    const body = response && response.error ? response.error : null;
    const detail = (body && (body.message || body.title || body.detail)) || (response && response.message) || '';
    if (response && response.status === 400 && String(detail).indexOf('موجودی') >= 0) {
      alert('کاربر گرامی موجودی انبار برای تحویل کالا کافی نیست!');
    } else if (detail) {
      alert('ذخیره سفارش ناموفق بود: ' + detail);
    } else {
      alert('ذخیره سفارش ناموفق بود. لطفاً فیلدهای ضروری را بررسی و دوباره تلاش کنید.');
    }
    if (response && response.status === 400) {
      this.serverValidationError = true;
    }

  }


  goToProfile(id) {
    this.router.navigate(['/page/profile-customer-project/' + id + '/project']);
    this.clear();
  }

  nextToAdd() {
    this.nextCustomerFormShow = true;

  }


  // sort2(predicate, reverse) {
  //   let result = ['itemName, asc'];
  //   if (predicate) {
  //     result = [predicate + ',' + reverse];
  //     return result;
  //   }
  // }

  edit() {
    this.phones = [];
    this.phones.length = 0;
    this.nextCustomerFormShow = false;
  }


  searchCustomer() {
    this.modalService.open(CustomerAdvancedSearchComponent, {
      size: 'lg',
      windowClass: 'crm-cust-pick-modal',
      backdrop: 'static',
      centered: true
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      if (reason && reason.id) {
        this.customer = reason;
        this.order.customer = reason;
        this.customerId = reason.id;
        this.search();
      }
    });
  }

  clearSelectedCustomer() {
    if (this.order && this.order.id) {
      return;
    }
    this.customer = new Customer();
    this.order.customer = null;
    this.customerId = null;
    this.phone_id = '';
    this.phones = [];
  }


  searchKala(i) {


    const modalRef = this.modalService.open(StockComponent, {
      size: 'lg',
      windowClass: 'crm-stock-pick-modal',
      backdrop: 'static',
      centered: true
    });
    modalRef.componentInstance.mode = 'popup';
    modalRef.componentInstance.status = this.order.status;
    modalRef.componentInstance.type = 'order';

    modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;

      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        if (!reason || !reason.id) {
          return;
        }
        this.stock = reason;
        const control = <FormArray>this.orderForm.controls['items'];
        this.let_add = true;

        if (control.length > 0) {
          for (let j = 0; j < control.length; j++) {
            if ((<FormGroup>control.at(j)).controls.stock.value) {
              this.stock2 = ((<FormGroup>control.at(j)).controls.stock.value);
              if (this.stock2.id == this.stock.id) {
                alert('این موجودی برای این سفارش قبلاً انتخاب شده!');
                this.let_add = false;
              }
            }
          }
        }
        if (this.let_add) {
          this.kala = this.stock.kala;

          if (this.kala.cost)
            (<FormGroup>control.at(i)).controls.cost.setValue(this.numberWithCommas(this.kala.cost));
          (<FormGroup>control.at(i)).controls.cost_total.setValue(this.kala.cost);
          (<FormGroup>control.at(i)).controls.kala.setValue(this.kala);
          (<FormGroup>control.at(i)).controls.stock.setValue(this.stock);
          (<FormGroup>control.at(i)).controls.status.setValue(this.kala.id);
          if ((<FormGroup>control.at(i)).controls.cost.value && (<FormGroup>control.at(i)).controls.count.value) {
            (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(Number(this.disNumberWithCommas((<FormGroup>control.at(i)).controls.cost.value + "")) * Number((<FormGroup>control.at(i)).controls.count.value)));
          }
          this.changeValueCount(i);
        }
      }
    );

// this.modalService.open(KalaComponent, {
//     this.modalService.open(StockComponent, {
//       // this.modalService.open(CustomerAdvancedSearchComponent, {
//       windowClass: 'sm',
//       backdrop: 'static'
//     }).result.then((result) => {
//       this.closeResult = `Closed with: ${result}`;
//
//     }, (reason) => {
//       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
//       // this.kala = reason;
//       this.stock = reason;
//       this.kala = this.stock.kala;
//
//       const control = <FormArray>this.orderForm.controls['items'];
//       (<FormGroup>control.at(i)).controls.cost.setValue(this.numberWithCommas(this.kala.cost));
//       (<FormGroup>control.at(i)).controls.cost_total.setValue(this.kala.cost);
//       (<FormGroup>control.at(i)).controls.kala.setValue(this.kala);
//       (<FormGroup>control.at(i)).controls.stock.setValue(this.stock);
//       (<FormGroup>control.at(i)).controls.status.setValue(this.kala.id);
//       if ((<FormGroup>control.at(i)).controls.cost.value && (<FormGroup>control.at(i)).controls.count.value) {
//         (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(Number(this.disNumberWithCommas((<FormGroup>control.at(i)).controls.cost.value + "")) * Number((<FormGroup>control.at(i)).controls.count.value)));
//       }
//       this.changeValueCount(i);
//     });
  }

  previousState() {
    window.history.back();
  }

  private onSuccessFiles(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    this.spinner.hide();

  }

  loadAllFiles() {
    this.spinner.show();

    if (this.order.id) {
      this.fileObjectService.findWithOrderId({
        page: 0,
        size: 20
      }, this.order.id).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    }
  }

//   openFileOrder(order) {
// alert('order='+order.id);
//     const modalRef = this.modalService.open(FileObjectUpdateComponent, {size: 'sm', backdrop: 'static'});
//     modalRef.componentInstance.action = 'add';
//     modalRef.componentInstance.customerId = this.customer.id;
//     modalRef.componentInstance.orderId = order;
//
//     modalRef.result.then(res => {
//       console.log(res + ' the result of popup');
//       this.loadAllFiles();
//     }, rejected => {
//       console.log(' rejected: ' + rejected.toString());
//       this.loadAllFiles();
//     });
//
//   }
  openFileOrder(order, customer) {
    // alert(' order=' + order)
    // alert(' customer=' + customer)
    // alert(' customer='+customer.id)
    // alert(' order=' + order.id)


    const modalRef = this.modalService.open(FileObjectUpdateComponent, {size: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.customerId = customer;
    modalRef.componentInstance.orderId = order;

    modalRef.result.then(res => {
      console.log(res + ' the result of popup');
      this.loadAllFiles();
    }, rejected => {
      console.log(' rejected: ' + rejected.toString());
      this.loadAllFiles();
    });

  }

  changeValueCount(i) {

    const control = <FormArray>this.orderForm.controls['items'];
    if (control && control.length > 0) {

      if ((<FormGroup>control.at(i)).controls.cost.value && (<FormGroup>control.at(i)).controls.count.value) {
        if (((<FormGroup>control.at(i)).controls.kala.value)) {
          (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(Number((((<FormGroup>control.at(i)).controls.kala.value).cost)) * Number((<FormGroup>control.at(i)).controls.count.value)));
        }
      }

      const t = (Number((<FormGroup>control.at(i)).controls.discount.value)) * 0.01;

      if ((<FormGroup>control.at(i)).controls.discount.value) {
        (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(
          Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value))) -
          t * (Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value + ""))))
        ));
      }
      // const control = <FormArray>this.orderForm.controls['items'];
      this.sum_amount_order_items = 0;

      for (let i = 0; i < control.length; i++) {
        if ((<FormGroup>control.at(i)).controls.cost_total.value) {

          this.sum_amount_order_items = this.sum_amount_order_items + (Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value + ""))))
        }
      }
    }
    this.order.total_sum = this.sum_amount_order_items;
    if (this.order.taxation && this.order.discount) {

      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation))) - Number(this.disNumberWithCommas(this.order.discount));
    } else if (this.order.taxation) {
      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation)));
    } else if (this.order.discount) {
      this.total_amount_order_final = ( Number(this.order.total_sum)) - Number(this.disNumberWithCommas(this.order.discount));
    } else {
      this.total_amount_order_final = Number(this.order.total_sum);
    }

    this.order.factor_amount_number = this.total_amount_order_final;

  }

  changeValueCountForRemove(i) {

    let control = <FormArray>this.orderForm.controls['items'];
    if (control && control.length > 0) {

      if ((<FormGroup>control.at(i)).controls.cost.value && (<FormGroup>control.at(i)).controls.count.value) {
        if (((<FormGroup>control.at(i)).controls.kala.value)) {
          (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(Number((((<FormGroup>control.at(i)).controls.kala.value).cost)) * Number((<FormGroup>control.at(i)).controls.count.value)));
        }
      }

      const t = (Number((<FormGroup>control.at(i)).controls.discount.value)) * 0.01;

      if ((<FormGroup>control.at(i)).controls.discount.value) {
        (<FormGroup>control.at(i)).controls.cost_total.setValue(this.numberWithCommas(
          Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value))) -
          t * (Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value + ""))))
        ));
      }
      this.sum_amount_order_items = 0;
      control = <FormArray>this.orderForm.controls['items'];
      control.removeAt(i);
      control = <FormArray>this.orderForm.controls['items'];

      for (let i = 0; i < control.length; i++) {
        if ((<FormGroup>control.at(i)).controls.cost_total.value) {

          this.sum_amount_order_items = this.sum_amount_order_items + (Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value + ""))))
        }
      }
    }
    this.order.total_sum = this.sum_amount_order_items;
    if (this.order.taxation && this.order.discount) {

      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation))) - Number(this.disNumberWithCommas(this.order.discount));
    } else if (this.order.taxation) {
      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation)));
    } else if (this.order.discount) {
      this.total_amount_order_final = ( Number(this.order.total_sum)) - Number(this.disNumberWithCommas(this.order.discount));
    } else {
      this.total_amount_order_final = Number(this.order.total_sum);
    }

    this.order.factor_amount_number = this.total_amount_order_final;
    // alert('END this.sum_amount_order_items=' + this.sum_amount_order_items);

  }

  changeValueCountTotal() {
    this.numberWithCommasDiscount();
    this.numberWithCommasTax();
    const control = <FormArray>this.orderForm.controls['items'];
    // let length: any = (<IOrderItems[]>this.order.orderItems).length;
    this.sum_amount_order_items = 0;
    for (let i = 0; i < control.length; i++) {
      if ((<FormGroup>control.at(i)).controls.cost_total.value) {
        this.sum_amount_order_items = this.sum_amount_order_items + (Number(this.disNumberWithCommas(((<FormGroup>control.at(i)).controls.cost_total.value + ""))))
      }
    }

    this.order.total_sum = this.sum_amount_order_items;

    if (this.order.taxation && this.order.discount) {
      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation))) - Number(this.disNumberWithCommas(this.order.discount));
    } else if (this.order.taxation) {
      this.total_amount_order_final = ( Number(this.order.total_sum) + Number(this.disNumberWithCommas(this.order.taxation)));
    } else if (this.order.discount) {
      this.total_amount_order_final = ( Number(this.order.total_sum)) - Number(this.disNumberWithCommas(this.order.discount));
    } else {
      this.total_amount_order_final = Number(this.order.total_sum);
    }
    this.order.factor_amount_number = this.total_amount_order_final;
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.phoneService.delete(id).subscribe(response => {

      this.activeModal.dismiss(true);
    });
  }


  save() {
    if (!this.customerId && !(this.customer && this.customer.id)) {
      this.isSaving = false;
      alert('لطفاً مشتری مرتبط را انتخاب کنید.');
      return;
    }
    if (!this.order.factor_amount) {
      this.isSaving = false;
      alert('لطفاً مبلغ کل سفارش را وارد کنید.');
      return;
    }
    if (!this.order.itemName || !String(this.order.itemName).trim()) {
      const cTitle = (this.customer && this.customer.title) || 'فروش کالا';
      this.order.itemName = 'سفارش ' + cTitle;
    }

    if (this.resolveEmployeeId() == null) {
      this.resolveResponsibleThenPersist();
      return;
    }
    this.persistOrder();
  }

  /** اگر مسئول هنوز ست نشده، از کاربر لاگین‌شده resolve کن و بعد ذخیره کن */
  private resolveResponsibleThenPersist() {
    this.spinner.show();
    this.accountService.identity().then(account => {
      if (!account) {
        this.spinner.hide();
        this.isSaving = false;
        alert('مسئول سفارش مشخص نشد. لطفاً دوباره وارد سیستم شوید.');
        return;
      }
      const userKey = account.id != null ? account.id : account.login;
      const tryFromListThenFail = () => {
        if (this.applyResponsibleFromEmployeeList(account)) {
          this.persistOrder();
          return;
        }
        // یک بار دیگر لیست پرسنل را کامل بگیر و دوباره تلاش کن
        this.employeeService.query({page: 0, size: 500}).subscribe(
          (res: HttpResponse<IEmployee[]>) => {
            this.employees = res.body || [];
            if (this.applyResponsibleFromEmployeeList(account)) {
              this.persistOrder();
              return;
            }
            this.spinner.hide();
            this.isSaving = false;
            alert('حساب کاربری شما به پرسنل وصل نیست. لطفاً با مدیر سیستم هماهنگ کنید.');
          },
          () => {
            this.spinner.hide();
            this.isSaving = false;
            alert('مسئول سفارش مشخص نشد. حساب کاربری شما به پرسنل متصل نیست.');
          }
        );
      };

      if (userKey == null || userKey === '') {
        tryFromListThenFail();
        return;
      }

      this.employeeService.findByUserId(userKey).subscribe(
        (empl: HttpResponse<IEmployee>) => {
          if (empl.body && empl.body.id) {
            this.order.employee_str = empl.body.id;
            this.persistOrder();
            return;
          }
          tryFromListThenFail();
        },
        () => tryFromListThenFail()
      );
    });
  }

  private applyResponsibleFromEmployeeList(account: any): boolean {
    const list = this.employees || [];
    const found = list.find(e => {
      if (!e || !e.id) {
        return false;
      }
      if (e.user && (e.user.id === account.id || e.user.login === account.login)) {
        return true;
      }
      if (e.login && account.login && e.login === account.login) {
        return true;
      }
      return false;
    });
    if (found) {
      this.order.employee_str = found.id;
      return true;
    }
    return false;
  }

  private resolveEmployeeId(): number | null {
    const fromStr = this.order.employee_str != null && this.order.employee_str !== ''
      ? Number(this.order.employee_str)
      : NaN;
    if (!isNaN(fromStr) && fromStr > 0) {
      return fromStr;
    }
    const fromEmp = this.order.employee && this.order.employee.id != null
      ? Number(this.order.employee.id)
      : NaN;
    if (!isNaN(fromEmp) && fromEmp > 0) {
      return fromEmp;
    }
    return null;
  }

  private persistOrder() {
    const empId = this.resolveEmployeeId();
    if (empId == null) {
      this.spinner.hide();
      this.isSaving = false;
      alert('مسئول سفارش مشخص نشد. حساب کاربری شما به پرسنل متصل نیست.');
      return;
    }
    this.order.employee_str = String(empId);
    this.spinner.show();
    this.isSaving = true;
    this.order.type = 'order';
    if (!this.order.id && !this.order.status) {
      this.order.status = 'pre_invoice';
    }
    if (this.order.require_finance_approval === undefined || this.order.require_finance_approval === null) {
      this.order.require_finance_approval = false;
    }
    this.updateOrder(this.order);
    this.sanitizeOrderPayload();

    if (this.order.id) {
      this.subscribeToSaveResponse(this.orderService.update(this.order));
    } else {
      delete this.order.id;
      this.subscribeToSaveResponse(this.orderService.create(this.order));
    }
  }

  saveAndContinue() {
    this.continueAfterSave = true;
    this.save();
  }

  private sanitizeOrderPayload() {
    this.order.organization = {id: 1} as any;
    if (this.phone_id) {
      this.order.phone = {id: Number(this.phone_id)} as any;
    } else {
      this.order.phone = null;
    }
    if (this.customerId) {
      this.order.customer = {id: Number(this.customerId)} as any;
    } else if (this.customer && this.customer.id) {
      this.order.customer = {id: Number(this.customer.id)} as any;
      this.customerId = this.customer.id;
    }
    const empId = this.resolveEmployeeId();
    if (empId != null) {
      // Only id — never send a full Employee stub (causes Hibernate transient errors)
      this.order.employee = {id: empId} as IEmployee;
      this.order.employee_str = String(empId);
    } else {
      this.order.employee = null;
    }

    if (this.strDateObject) {
      this.order.send_order_date_str = moment(this.strDateObject).locale('en').format('ddd MMM DD YYYY HH:mm:ss');
    } else {
      this.order.send_order_date_str = null;
    }
    if (this.strDateObject2) {
      this.order.return_order_date_str = moment(this.strDateObject2).locale('en').format('ddd MMM DD YYYY HH:mm:ss');
    } else {
      this.order.return_order_date_str = null;
    }

    if (this.total_amount_order_final) {
      this.order.factor_amount = String(this.disNumberWithCommas(this.total_amount_order_final));
    } else {
      this.order.factor_amount = String(this.disNumberWithCommas(this.order.factor_amount));
    }
    this.order.factor_amount_number = this.disNumberWithCommas(this.order.factor_amount_number);
    this.order.taxation = String(this.disNumberWithCommas(this.order.taxation));
    this.order.discount = String(this.disNumberWithCommas(this.order.discount));
    this.order.total_sum = this.disNumberWithCommas(this.order.total_sum);

    const rawItems = this.order.orderItems || [];
    this.order.orderItems = rawItems
      .map((item: any) => {
        if (!item || !item.kala || !item.kala.id) {
          return null;
        }
        const clean: any = {
          count: Number(item.count) || 1,
          cost: this.disNumberWithCommas(item.cost),
          cost_total: this.disNumberWithCommas(item.cost_total),
          discount: this.disNumberWithCommas(item.discount) || 0,
          status: item.status || null,
          kala: {id: item.kala.id},
          organization: {id: 1}
        };
        if (item.id !== null && item.id !== undefined && item.id !== '' && !isNaN(Number(item.id))) {
          clean.id = Number(item.id);
        }
        if (item.stock && item.stock.id) {
          clean.stock = {id: item.stock.id};
        }
        return clean;
      })
      .filter(item => !!item);

    delete (this.order as any).phone_id;
    delete (this.order as any).strDateObject;
    delete (this.order as any).strDateObject2;
  }

  renderTime() {

    let delta = Math.abs(new Date(this.order.return_order_date_str).getTime() - new Date(this.order.send_order_date_str).getTime())/ 1000;

    // let delta = Math.abs(Number(new Date(this.order.send_order_date_str) - new Date(this.order.return_order_date_str))) / 1000;

// calculate (and subtract) whole days
    let days = Math.floor(delta / 86400);
    delta -= days * 86400;

// calculate (and subtract) whole hours
    let hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

// calculate (and subtract) whole minutes
    let minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

// what's left is seconds
    let seconds = delta % 60;  // in theory the modulus is not required
    //
    let temp = '';
    if (days > 0) {
      temp = days + ' روز'
    }
    if (hours > 0) {
      if (days > 0) {
        temp = temp + ' و ' + hours + ' ساعت'
      } else {
        temp = hours + ' ساعت'
      }
    }
    if (minutes > 0) {
      if (hours > 0 || days > 0) {
        temp = temp + ' و ' + minutes + ' دقیقه'

      } else {
        temp = minutes + ' دقیقه'

      }

    }
    // alert('delta='+delta);
    // alert('days='+days);
    // alert('hours='+hours);
    // alert('minutes='+minutes);
    // alert('seconds='+seconds);
    return temp;
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IOrder>>) {
    result.subscribe((res: HttpResponse<IOrder>) => this.onSaveSuccessOrder(res), (res: HttpErrorResponse) => this.onSaveError(res));
  }


  protected onSaveSuccessOrder(res) {
    this.order = res.body;
    this.order2 = res.body;
    this.order.step = Number(this.order.step);
    if (this.order.employee && this.order.employee.id) {
      this.order.employee_str = String(this.order.employee.id);
    }

    this.isSaving = false;
    this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');
    this.spinner.hide();
    this.eventService.onResponseStock('test message 22');

    if (this.editFormFile.get(['content']).value) {
      this.continueAfterSave = false;
      this.openIncomingAfterSave = false;
      this.saveFile();
      return;
    }

    if (this.continueAfterSave) {
      this.continueAfterSave = false;
      this.confirmSalesFlow();
      return;
    }

    if (this.openIncomingAfterSave) {
      this.openIncomingAfterSave = false;
      this.loadOrderIncomings();
      this.launchIncomingModal();
      return;
    }

    // Stay on sales-flow document so user can advance steps
    if (this.order && this.order.id && this.order.customer && this.order.customer.id) {
      this.router.navigate(['/page/order/' + this.order.id + '/' + this.order.customer.id]);
      return;
    }
    if (this.order && this.order.id && this.customerId) {
      this.router.navigate(['/page/order/' + this.order.id + '/' + this.customerId]);
      return;
    }
    this.router.navigate(['/page/orders']);
  }

  steAudienceNumber(val) {
    this.order.audience_phone = val;
  }

  numberWithCommasNumber() {
    const cost = this.order.factor_amount;
    const y = this.numberWithCommas(cost);
    this.order.factor_amount = y;
    this.order.factor_amount_number = Number(this.numberWithoutCommas(cost));

  }

  numberWithCommasTax() {
    if (this.order.taxation) {
      const temp = this.order.taxation;
      const y = this.numberWithCommas(temp);
      this.order.taxation = y;
    }
  }

  numberWithCommasDiscount() {
    if (this.order.discount) {
      const temp = this.order.discount;
      const y = this.numberWithCommas(temp);
      this.order.discount = y;
    }
  }

  numberWithoutCommas(x) {

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    return x;

  }
  sort2(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  loadAllStocksTotal() {

    this.stockService.query(
      {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2('id', 'asc'),

      }
    ).subscribe(
      // this.stockService.findMyStock(employeeId).subscribe(
      (res: HttpResponse<IStock[]>) => {
        this.stocks = res.body;
        this.spinner.hide();

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  protected paginateStock(data: IStock[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.stocks = data;

    this.spinner.hide();

  }
  loadOrdersCalnedar() {
    if (this.stock_temp === '-1') {
      this.orderItemService
        .query()
        .subscribe(
          (res: HttpResponse<OrderItems[]>) => this.paginateOrder(res.body, res.headers),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    } else {
      const stock_temp = (this.stock_temp).trim();
      this.orderItemService
        .getListOrderItemsByByFilter(stock_temp)
        .subscribe(
          (res: HttpResponse<OrderItems[]>) => this.paginateOrder(res.body, res.headers),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    }

  }

  protected paginateOrder(data: OrderItems[], headers: HttpHeaders) {
    this.orders_calendar = data;

    if (this.orders_calendar && this.orders_calendar.length > 0) {
    } else {
    }

    this.calendarEvents2 = [];
    this.orders_calendar.forEach((item) => {
      if (item.order.send_order_date && item.order.return_order_date ) {

        const temp = {
          title:  item.order.customer.title + '/'+item.stock.kala.title+','+item.stock.kala.code,
          description: item.order.itemName,
          start: item.order.send_order_date,
          end: item.order.return_order_date,
          backgroundColor:(item.order.status === 'delivered' ? '#05ca91' :
              (item.order.status === 'returned' ? '#767676' :
                  (item.order.status === 'approved' ? '#17a2b8' :
                    (item.order.status === 'created' ? '#e98765' : '#f62408')
                  )
              )
          ),
          eventColor: '#05ca91',
          eventTextColor: '#f62408'
        };
        this.calendarEvents2 = this.calendarEvents2.concat(temp);
      }

    })

    // this.loadAllProjectStep();
  }

  updateFormFile(fileObject: IFileObject) {
    this.editFormFile.patchValue({
      id: fileObject.id,
      title: fileObject.title,
      content: fileObject.content,
      itemName: fileObject.contentType,
      size: fileObject.contentType,
      isImgProfile: fileObject.isImgProfile,
      imgProfile: fileObject.imgProfile,
      status: fileObject.status,
      uploaded_by: fileObject.uploaded_by,
      contentType: (fileObject.contentType)
    });
    this.editFormFile2.patchValue({
      id: fileObject.id,
      title: fileObject.title,
      content: fileObject.content,
      itemName: fileObject.contentType,
      size: fileObject.contentType,
      isImgProfile: fileObject.isImgProfile,
      imgProfile: fileObject.imgProfile,
      status: fileObject.status,
      uploaded_by: fileObject.uploaded_by,
      contentType: (fileObject.contentType)
    });
  }

  byteSize(field) {
  }

  openFile(contentType, field) {
  }

  setFileData(event, field: string, isImage) {
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      () => console.log('blob added'),
      this.onError
    );


  }

  setFileData2(event, field: string, isImage) {
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile2.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      () => console.log('blob added'),
      this.onError
    );


  }

  saveFile() {
    this.isSaving = true;
    this.progress = Math.round(200 / 200 * 100);
    const fileObject = this.createFormFile();
    fileObject.customer = this.customer;
    fileObject.order = this.order;
    fileObject.title = 'رسید پرداخت'
    // if (this.transaction) {
    //   fileObject.transaction = this.transaction;
    // }
    // if (this.transaction.project) {
    //   fileObject.project = this.transaction.project;
    // }
    // if (this.transaction.salesCycle) {
    //   fileObject.salesCycle = this.transaction.salesCycle;
    // }
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.update(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.create(fileObject));
    }

  }

  saveFile2() {
    this.isSaving2 = true;
    this.progress2 = Math.round(200 / 200 * 100);
    const fileObject2 = this.createFormFile2();
    fileObject2.customer = this.customer;
    fileObject2.order = this.order;
    fileObject2.title = 'صادره انبار'
    // if (this.transaction) {
    //   fileObject.transaction = this.transaction;
    // }
    // if (this.transaction.project) {
    //   fileObject.project = this.transaction.project;
    // }
    // if (this.transaction.salesCycle) {
    //   fileObject.salesCycle = this.transaction.salesCycle;
    // }
    if (fileObject2.id !== undefined && fileObject2.id !== null) {
      this.subscribeToSaveResponseFile2(this.fileObjectService.update(fileObject2));
    } else {
      this.subscribeToSaveResponseFile2(this.fileObjectService.create(fileObject2));
    }

  }


  private createFormFile(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile.get(['id']).value,
      title: (this.title === 'profileImg' ? 'عکس پروفایل' : this.editFormFile.get(['title']).value),
      uploaded_by: (this.role ? this.role : this.editFormFile.get(['uploaded_by']).value),
      contentType: this.file_fileType,
      itemName: this.file_itemName,
      size: this.file_size,
      isImgProfile: false,
      imgProfile: false,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile.get(['content']).value
    };
  }

  private createFormFile2(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile2.get(['id']).value,
      title: (this.title === 'profileImg' ? 'عکس پروفایل' : this.editFormFile2.get(['title']).value),
      uploaded_by: (this.role ? this.role : this.editFormFile2.get(['uploaded_by']).value),
      contentType: this.file_fileType,
      itemName: this.file_itemName,
      size: this.file_size,
      isImgProfile: false,
      imgProfile: false,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile2.get(['content']).value
    };
  }


  protected subscribeToSaveResponseFile(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe(() => this.onSaveSuccessFile(), () => this.onSaveErrorFile());

  }

  protected onSaveSuccessFile() {
    this.isSaving = false;
    this.toastr.success('.ثبت فایل شما با موفقیت انجام شد', '!موفق');
    if (this.editFormFile2.get(['content']).value) {
      this.saveFile2();
    } else {
      this.router.navigate(['/page/orders']);
    }
  }


  protected subscribeToSaveResponseFile2(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe(() => this.onSaveSuccessFile2(), () => this.onSaveErrorFile());

  }

  protected onSaveSuccessFile2() {
    this.isSaving = false;
    this.toastr.success('.ثبت فایل شما با موفقیت انجام شد', '!موفق');
    this.router.navigate(['/page/orders']);
  }


  protected onSaveErrorFile() {
    this.isSaving = false;
  }

  nextFunc() {
    this.order.step = 1 + Number(this.order.step);
    // this.save();

  }

  prevFunc() {
    this.order.step = Number(this.order.step) - 1;
    // this.save();

  }

  changeStatus() {
    if (this.Delivered) {
      this.order.status = 'delivered';
    } else if (this.Approved) {
      this.order.status = 'approved';

    }
  }

  showFilesOrder(id) {
    const modalRef = this.modalService.open(FileObjectListProjectComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.orderId = id;
    modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
      }
    );
  }

  isSalesFlowStatus(status?: string): boolean {
    const s = status || this.order.status;
    return s === 'pre_invoice' || s === 'awaiting_finance' || s === 'confirmed'
      || s === 'warehouse_issued' || s === 'canceled' || s === 'returned'
      || s === 'created' || s === 'approved' || s === 'delivered';
  }

  isContentEditable(): boolean {
    return this.isCurrentStage('pre_invoice');
  }

  isFormLocked(): boolean {
    const s = this.order && this.order.status;
    return s === 'warehouse_issued'
      || s === 'delivered'
      || s === 'canceled'
      || s === 'returned';
  }

  /** فقط در مرحله مالی — کار اصلی این مرحله */
  showFinanceSection(): boolean {
    return this.isCurrentStage('awaiting_finance')
      || (this.isPastStage('awaiting_finance') && !!(this.orderIncomings && this.orderIncomings.length));
  }

  /** فقط در مرحله فاکتور (ویرایش) یا بعد از حواله (مشاهده) */
  showWarehouseSection(): boolean {
    return this.isCurrentStage('confirmed') || this.isCurrentStage('warehouse_issued');
  }

  showMorePanel = false;
  showPastSummary = false;
  showExtraInfo = false;
  continueAfterSave = false;
  openIncomingAfterSave = false;

  currentStageKey(): string {
    if (!this.order || !this.order.id || !this.order.status || this.order.status === 'created') {
      return 'pre_invoice';
    }
    if (this.order.status === 'approved' || this.order.status === 'delivered') {
      return 'warehouse_issued';
    }
    return this.order.status;
  }

  isCurrentStage(key: string): boolean {
    return this.currentStageKey() === key;
  }

  isPastStage(key: string): boolean {
    const keys = this.flowStepKeys();
    const cur = keys.indexOf(this.uiStageKey());
    const mine = keys.indexOf(key);
    if (cur < 0 || mine < 0) {
      return false;
    }
    return mine < cur;
  }

  /** کلید مرحله برای نوار پیشرفت (بدون وضعیت نهایی تکمیل) */
  uiStageKey(): string {
    const s = this.currentStageKey();
    if (s === 'warehouse_issued') {
      return 'confirmed';
    }
    return s;
  }

  currentStageNumber(): number {
    const keys = this.flowStepKeys();
    const idx = keys.indexOf(this.uiStageKey());
    return idx >= 0 ? idx + 1 : 1;
  }

  totalStageCount(): number {
    return this.flowStepKeys().length;
  }

  stepShortLabel(key: string): string {
    switch (key) {
      case 'pre_invoice': return 'ثبت سفارش';
      case 'awaiting_finance': return 'تأیید';
      case 'confirmed': return 'حواله';
      default: return key;
    }
  }

  flowStepperSteps(): { key: string; label: string; num: number; done: boolean; current: boolean; locked: boolean }[] {
    const keys = this.flowStepKeys();
    const finished = this.currentStageKey() === 'warehouse_issued';
    const curKey = finished ? null : this.uiStageKey();
    const curIdx = curKey ? keys.indexOf(curKey) : keys.length;
    const terminal = this.order && (this.order.status === 'canceled' || this.order.status === 'returned');
    return keys.map((key, i) => ({
      key,
      label: this.stepShortLabel(key),
      num: i + 1,
      done: !terminal && (finished || this.isStepDone(key)),
      current: !terminal && !finished && key === curKey,
      locked: terminal || (!finished && curIdx >= 0 && i > curIdx)
    }));
  }

  salesFlowHint(): string {
    const s = this.currentStageKey();
    if (this.order && this.order.status === 'canceled') {
      return 'این سفارش باطل شده است.';
    }
    if (this.order && this.order.status === 'returned') {
      return 'این سفارش برگشت خورده است.';
    }
    if (s === 'pre_invoice') {
      return 'مشتری و مبلغ الزامی است. مخاطب و اطلاعات اضافی اختیاری‌اند. در صورت نیاز به تأیید، دریافت‌ها را اینجا ثبت کنید.';
    }
    if (s === 'awaiting_finance') {
      return 'اطلاعات سفارش فقط خواندنی است. بررسی و تأیید کنید یا برای اصلاح به مرحله ثبت برگردید.';
    }
    if (s === 'confirmed') {
      return 'با تأیید حواله، موجودی کم می‌شود و سفارش بسته می‌شود. در صورت نیاز به اصلاح، به ثبت سفارش برگردید.';
    }
    if (s === 'warehouse_issued') {
      return 'حواله صادر شد و سفارش بسته شده است.';
    }
    return '';
  }

  stageFormTitle(): string {
    if (this.order && this.order.status === 'canceled') {
      return 'سفارش باطل‌شده';
    }
    if (this.order && this.order.status === 'returned') {
      return 'سفارش برگشتی';
    }
    const s = this.currentStageKey();
    if (s === 'pre_invoice') {
      return 'ثبت سفارش';
    }
    if (s === 'awaiting_finance') {
      return 'تأیید سفارش';
    }
    if (s === 'confirmed') {
      return 'حواله خروج';
    }
    if (s === 'warehouse_issued') {
      return 'سفارش بسته‌شده';
    }
    return 'فروش کالا';
  }

  stagePrimaryActionLabel(): string {
    const s = this.currentStageKey();
    if (s === 'pre_invoice') {
      return 'ثبت و ادامه';
    }
    if (s === 'awaiting_finance') {
      return 'تأیید و ادامه';
    }
    if (s === 'confirmed') {
      return 'تأیید حواله و کسر موجودی';
    }
    return '';
  }

  isStepDone(step: string): boolean {
    const s = this.order && this.order.status;
    if (!s || s === 'canceled' || s === 'returned') {
      return false;
    }
    if (s === 'warehouse_issued') {
      return true;
    }
    const keys = this.flowStepKeys();
    const cur = keys.indexOf(this.uiStageKey());
    const mine = keys.indexOf(step);
    if (cur < 0 || mine < 0) {
      return false;
    }
    return mine < cur;
  }

  flowStepKeys(): string[] {
    if (this.order && this.order.require_finance_approval) {
      return ['pre_invoice', 'awaiting_finance', 'confirmed'];
    }
    return ['pre_invoice', 'confirmed'];
  }

  progressLines(): { label: string; done: boolean; current: boolean }[] {
    const s = this.order && this.order.status;
    if (!s || !this.isSalesFlowStatus(s)) {
      return [];
    }
    const defs: { key: string; label: string }[] = [
      { key: 'pre_invoice', label: 'ثبت سفارش' }
    ];
    if (this.order.require_finance_approval) {
      defs.push({ key: 'awaiting_finance', label: 'تأیید' });
    }
    defs.push({ key: 'confirmed', label: 'حواله خروج' });

    const curKey = this.uiStageKey();
    const finished = this.currentStageKey() === 'warehouse_issued';
    const keys = defs.map(d => d.key);
    const cur = keys.indexOf(curKey);
    return defs.map((d, i) => ({
      label: d.label,
      done: finished || cur > i,
      current: !finished && curKey === d.key
    }));
  }

  salesFlowLabel(status?: string): string {
    const s = status || this.order.status;
    switch (s) {
      case 'pre_invoice': return 'ثبت سفارش';
      case 'awaiting_finance': return 'در انتظار تأیید';
      case 'confirmed': return 'آماده حواله';
      case 'warehouse_issued': return 'حواله صادر / بسته‌شده';
      case 'canceled': return 'باطل شده';
      case 'returned': return 'برگشت شده';
      case 'created': return 'ایجاد شده (قدیمی)';
      case 'approved': return 'تأیید شده (قدیمی)';
      case 'delivered': return 'تحویل شده (قدیمی)';
      default: return s || '—';
    }
  }

  flowStepActive(step: string): boolean {
    const keys = this.flowStepKeys();
    if (step === 'awaiting_finance' && !this.order.require_finance_approval) {
      return false;
    }
    if (this.currentStageKey() === 'warehouse_issued') {
      return keys.indexOf(step) >= 0;
    }
    const idx = keys.indexOf(this.uiStageKey());
    const stepIdx = keys.indexOf(step);
    if (idx < 0 || stepIdx < 0) {
      return this.uiStageKey() === step;
    }
    return stepIdx <= idx;
  }

  selectedPhoneLabel(): string {
    if (!this.phone_id || !this.phones) {
      return '—';
    }
    const p = this.phones.find(x => String(x.id) === String(this.phone_id));
    if (!p) {
      return '—';
    }
    return ((p.audience || '') + (p.jhiNumber ? ' / ' + p.jhiNumber : '')).trim() || '—';
  }

  private applyFlowResult(res: HttpResponse<IOrder>) {
    this.order = res.body;
    this.order2 = res.body;
    if (this.order.employee && this.order.employee.id) {
      this.order.employee_str = String(this.order.employee.id);
    }
    this.flowBusy = false;
    this.spinner.hide();
    this.toastr.success('وضعیت سفارش به‌روز شد.', 'کاربر گرامی!');
    const nextTab = (this.order && this.order.status) ? this.order.status : '';
    this.router.navigate(['/page/orders'], {
      queryParams: nextTab ? { tab: nextTab } : {}
    });
  }

  private onFlowError(err: HttpErrorResponse) {
    this.flowBusy = false;
    this.spinner.hide();
    const msg = (err && err.error && (err.error.title || err.error.message || err.error.detail))
      || 'انجام مرحله ممکن نبود.';
    this.toastr.error(String(msg), 'خطا');
  }

  confirmSalesFlow() {
    if (!this.order.id) {
      alert('ابتدا سفارش را ذخیره کنید.');
      return;
    }
    this.flowBusy = true;
    this.spinner.show();
    this.orderService.confirmSalesFlow(this.order.id).subscribe(
      (res) => this.applyFlowResult(res),
      (err) => this.onFlowError(err)
    );
  }

  approveFinanceSalesFlow() {
    if (!this.order.id) {
      return;
    }
    this.flowBusy = true;
    this.spinner.show();
    this.orderService.approveFinanceSalesFlow(this.order.id).subscribe(
      (res) => this.applyFlowResult(res),
      (err) => this.onFlowError(err)
    );
  }

  revertPreInvoiceSalesFlow() {
    if (!this.order.id) {
      return;
    }
    if (!confirm('سفارش برای اصلاح به مرحله ثبت برگردد؟')) {
      return;
    }
    this.flowBusy = true;
    this.spinner.show();
    this.orderService.revertPreInvoiceSalesFlow(this.order.id).subscribe(
      (res) => this.applyFlowResult(res),
      (err) => this.onFlowError(err)
    );
  }

  issueWarehouseSalesFlow() {
    if (!this.order.id) {
      return;
    }
    if (!confirm('حواله خروج زده شود، موجودی کم شود و سفارش بسته شود؟')) {
      return;
    }
    const empId = this.resolveEmployeeId();
    if (empId == null) {
      alert('مسئول سفارش مشخص نشد. لطفاً صفحه را رفرش کنید.');
      return;
    }
    this.order.employee_str = String(empId);
    this.flowBusy = true;
    this.spinner.show();
    this.updateOrder(this.order);
    this.sanitizeOrderPayload();
    this.orderService.update(this.order).subscribe(
      () => {
        this.orderService.issueWarehouseSalesFlow(this.order.id).subscribe(
          (res) => this.applyFlowResult(res),
          (err) => this.onFlowError(err)
        );
      },
      (err) => this.onFlowError(err)
    );
  }

  cancelSalesFlow() {
    if (!this.order.id) {
      return;
    }
    if (!confirm('سفارش باطل شود؟')) {
      return;
    }
    this.flowBusy = true;
    this.spinner.show();
    this.orderService.cancelSalesFlow(this.order.id).subscribe(
      (res) => this.applyFlowResult(res),
      (err) => this.onFlowError(err)
    );
  }

  loadOrderIncomings() {
    if (!this.order || !this.order.id) {
      this.orderIncomings = [];
      return;
    }
    this.incomingService.findWithOrderId({page: 0, size: 50}, this.order.id).subscribe(
      (res: HttpResponse<IIncoming[]>) => {
        this.orderIncomings = res.body || [];
      },
      () => {
        this.orderIncomings = [];
      }
    );
  }

  openIncomingForOrder() {
    if (this.order && this.order.id) {
      this.launchIncomingModal();
      return;
    }
    if (!this.customerId && !(this.customer && this.customer.id)) {
      this.toastr.warning('لطفاً ابتدا مشتری مرتبط را انتخاب کنید.');
      return;
    }
    if (!this.order.factor_amount) {
      this.toastr.warning('لطفاً مبلغ کل سفارش را وارد کنید.');
      return;
    }
    // ذخیره موقت سفارش بدون رفتن به مرحله بعد، بعد باز شدن همان مدال دریافت
    this.openIncomingAfterSave = true;
    this.continueAfterSave = false;
    this.save();
  }

  private launchIncomingModal() {
    const modalRef = this.modalService.open(IncomingUpdateComponent, {
      windowClass: 'lg crm-incoming-modal',
      backdrop: 'static'
    });
    modalRef.componentInstance.formType = 'receive';
    modalRef.componentInstance.orderId = this.order.id;
    modalRef.componentInstance.customerId = this.customerId || (this.order.customer && this.order.customer.id);
    modalRef.result.then(
      () => this.loadOrderIncomings(),
      () => this.loadOrderIncomings()
    );
  }

}
